<template>
    <div>
        <DataTable
            :value="metrics"
            :lazy="true"
            paginator
            :rows="10"
            selectionMode="single"
            :loading="state.loading"
            @page="onPage"
            dataKey="id"
            :totalRecords="totalRecords"
            responsiveLayout="scroll"
            :rowsPerPageOptions="[5, 10, 20, 50]"
            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
        >
            <template #empty> No metrics available. </template>
            <template #loading> Loading Metrics. Please wait. </template>
            <Column field="metric.id" header="ID" style="width: 4rem" />
            <Column field="metric.name" header="NAME" style="width: 8rem" />
            <Column field="metric.description" header="DESCRIPTION" style="width: 16rem" />
            <Column field="metric.sharable" header="Shared" style="width: 2rem">
                <template #body="slotProps">
                    <Tag :severity="slotProps.data.metric.sharable === 1 ? 'warning' : 'info'" :value="slotProps.data.metric.sharable === 1 ? 'True' : 'False'" rounded />
                </template>
            </Column>
            <Column field="actions" header="ACTIONS" style="width: 6rem">
                <template #body="slotProps">
                    <!-- View needed  -->
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" v-tooltip="'Edit User Group'" @click="operateMetric(slotProps.data.metric.id, 'edit')" :disabled="!checkUserPermission(UserPermissions.WRITE_METRIC)" />
                    <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2" v-tooltip="'Delete User Group'" @click="confirmDelete(slotProps.data.metric.id)" :disabled="!checkUserPermission(UserPermissions.DELETE_METRIC)" />
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script setup>
import { reactive, watch, onMounted, defineProps, computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';

// import { useMetricComposable } from '@/composables/MetricComposable';
import useUserComposable from '@/composables/UserComposable';

import { UserPermissions } from '../../enums';
//import { formatDate } from '@/helpers/date-formatter';
import GlobalRequest from '@/api/global-request';

// const { removeMetric } = useMetricComposable();
const { checkUserPermission } = useUserComposable();

const router = useRouter();
const confirm = useConfirm();
const toast = useToast();
import { useStore } from 'vuex';
const store = useStore();

const company_id = computed(() => {
    return store.getters['auth/userCompanyId']?.id;
});

const props = defineProps({
    reloadTable: {
        type: Boolean,
        required: false,
    },
});

const createInitialState = () => {
    return reactive({
        loading: false,
        lazyParams: {},
    });
};

const state = createInitialState();
watch(
    () => props.reloadTable,
    () => {
        loadLazyData();
    }
);

onMounted(async () => {
    state.loading = true;
    state.lazyParams = {
        first: 0,
        rows: 10,
        page: null,
    };
    await loadLazyData();
});

const metrics = ref([]);
const totalRecords = ref(0);

const loadLazyData = () => {
    state.loading = true;

     GlobalRequest.getRequest('/v2/datasource/metric', {
         params: {
             first: state.lazyParams.first,
             page_size: state.lazyParams.rows,
             page: state.lazyParams.page ? state.lazyParams.page + 1 : 1,
             company_id: company_id.value,
             paginate: true,
         },
     }).then((response) => {
         if (response.statusCode === 200) {
             state.loading = false;

             metrics.value = response.data.data;

             totalRecords.value = response.data.total;
         }
     });

};

const onPage = async (event) => {
    // console.log(event);
    state.lazyParams = event;
    await loadLazyData();
};

const operateMetric = async (id, mode) => {
    if (mode == 'edit') {
        router.push({ name: 'UpdateMetric', params: { id } });
    }
};

const confirmDelete = (id) => {
    confirm.require({
        header: 'Delete Confirmation',
        message: 'Are you sure you want to delete metric  ' + id + '?',
        icon: 'pi pi-info-circle',
        accept: async () => {

            GlobalRequest.deleteRequest('/v2/datasource/metric/'+id, {
                params: {
                    company_id: company_id.value,
                },
            }).then((response) => {
                if (response.statusCode === 200) {
                    loadLazyData();
                }
            }).catch(async (error) => {
                console.log('error', error);
                //router.go(-1)
            });

            //await removeMetric(id);
            // reload table as needed
            // await loadLazyData();
        },
        reject: () => {
            toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
        },
    });
};
</script>

<style lang="scss" scoped>
td > ul {
    padding-left: 0;
}
.metric-data-type {
    font-size: 0.85rem;
}
</style>
